<script setup>
import { getAuthor } from '~/composables/builder/api';

const props = defineProps({
    page: {
        type: Object,
        required: false,
    },
});

const { data: author, error } = useLazyAsyncData(`getAuthor-${props.page.data.author.id}`, () =>
    getAuthor(props.page.data.author.id)
);

const displayName = computed(() => author.value?.name?.replace(/INBOUND/g, 'UNBOUND') || '');
</script>

<template>
    <div v-if="author" class="blog-author mx-auto mt-10 pt-10 pb-10 flex gap-9.5 items-center text-(--magenta) border-t border-(--dark-pink) max-md:px-7.5 max-md:py-8 max-md:gap-6 px-(--box-padding-lr-m) lg:px-(--box-padding-lr)">
        <div class="image size-18 rounded-(--radius) overflow-hidden max-md:size-16">
            <img v-if="author.name?.includes('INBOUND') || author.name?.includes('UNBOUND')" src="/img/2026/blog-avatar.png" srcset="/img/2026/blog-avatar.png 1x, /img/2026/blog-avatar@2x.png 2x" :alt="author.name" class="size-full object-contain" />
            <MessImage v-else :src="author.data.authorImage" :alt="author.name" />
        </div>
        <div class="name-description max-md:w-[calc(100%-4rem-1.5rem)]">
            <p class="name font-hubspot-serif text-[calc(18/var(--base-fs)*1rem)] font-normal leading-[150%] max-md:text-[16px]">{{ displayName }}</p>
            <p class="description font-hubspot-sans text-[calc(16/var(--base-fs)*1rem)] font-light leading-[160%] tracking-[0.48px] max-md:text-[12px]">{{ author.data.authorDescription }}</p>
        </div>
    </div>
</template>

<style>
/* [child] image border-radius */
.blog-author .image .mess-image {
    border-radius: var(--radius);
    overflow: hidden;
}
</style>
